let cookies = []

export const deleteAllCookies = () => {
	var cookies = document.cookie.split(';')

	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i]
		var eqPos = cookie.indexOf('=')
		var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
		document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
	}
}

export const updateCookiesArray = () => {
	cookies = [] 
	const response = document.cookie.split(';')
	response.forEach((cookie) => {
		const res = cookie.split('=')
		if (res[0] && res[1]) {
			cookies.push({
				key: res[0].split(' ').join(''),
				value: res[1], 
			})
		}
	})
}

export const getCookieInArray = (key) => cookies.find((cookie) => cookie.key === key)

export function getCookie(name) {
	const value = `; ${document.cookie}`
	const parts = value.split(`; ${name}=`)
	if (parts.length === 2) return parts.pop().split(';').shift()
}

export function getCookieString(name) {
	const cookie = getCookie(name)
	if (!cookie) return null
	return cookie
}

function looksLikeBase64(str) {
	if (!str) return false
	const sanitized = str.replace(/=+$/, '')
	if (str.length % 4 !== 0) return false
	if (str.includes('.') && str.split('.').length === 3) return false
	return /^[A-Za-z0-9+/]+$/.test(sanitized)
}

function safeAtob(val) {
	try { return atob(val) } catch { return null }
}

export function logPossibleBase64Cookies(options = {}) {
	const { decode = true, maxLen = 500 } = options
	if (typeof document === 'undefined') return
	const raw = document.cookie
	if (!raw) {
		console.info('[cookies][b64] Sem cookies para inspecionar')
		return
	}
	console.group('[cookies][b64] Inspeção de possíveis cookies base64')
	raw.split(';').map(c => c.trim()).forEach(pair => {
		if (!pair) return
		const eq = pair.indexOf('=')
		if (eq === -1) return
		const name = pair.substring(0, eq)
		const value = pair.substring(eq + 1)
		if (looksLikeBase64(value)) {
			const decoded = decode ? safeAtob(value) : null
			console.log(`• ${name}:`, {
				raw: value.length > maxLen ? value.slice(0, maxLen) + '…' : value,
				decoded: decoded && decoded.length > maxLen ? decoded.slice(0, maxLen) + '…' : decoded,
				rawLength: value.length,
				decodedLength: decoded?.length || 0
			})
		}
	})
	console.groupEnd()
}